import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';

@Injectable()
export class LazyPreloadingStrategy implements PreloadingStrategy {

    preload(route: Route, loadModule): Observable<any> {
        return route?.data?.applyPreload ? loadModule() : EMPTY;
    }

}
